import { render, staticRenderFns } from "./simpleMoneyTable.vue?vue&type=template&id=36da8799&scoped=true&"
import script from "./simpleMoneyTable.vue?vue&type=script&lang=js&"
export * from "./simpleMoneyTable.vue?vue&type=script&lang=js&"
import style0 from "./simpleMoneyTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../statistics/css/moneyTable.css?vue&type=style&index=1&id=36da8799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da8799",
  null
  
)

export default component.exports